// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1_I3P","footer":"ModalInfo_footer__3p5oq"};